import React, { useEffect, useState } from "react";
import "./FormQuestion.scss";
import FormItem from "./formItem";
import { getCLientFormResponse } from "../../../../services/firebase/firestore/getData";


export default function FormQuestion({ form, filter="All", initial }) {
    const [formData, setForm] = useState(initial);

    useEffect(() => {
        let all_forms = { name: 'All', form: [] };
        setForm([]);



        if (form) {
            form.map((item) => {
                if(filter === "All") {
                    item.form.map(doc => {
                        all_forms.form.push(doc); 
                    })
                    setForm(all_forms);
                    //console.log(all_forms);
                }else if(filter === "Feedback form") {
                if(item.name.toLowerCase() === "feedback_form") {
                    setForm(item);
                }
                }else if(filter === "Coach" || filter === "Goals" || filter === "Lifestyle" || filter === "Medical" || filter === "Nutrition") {
                    if(item.name.toLowerCase() === filter.toLowerCase()) {
                        setForm(item);
                    }
                } 
            })
        }
    }, [filter, form]);

    return (
        <div>
            { form && formData.form ? ( 
                <FormItem item={formData} />
            ):(
                <div></div>
            )}
        </div>
    )
}
